import dayjs from "dayjs";
import useFormValidation from "hooks/useFormValidation";
import { Button } from "primereact/button";
import { Calendar, CalendarValueType } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import styled from "styled-components";

const StyledCalendar = styled(Calendar)`
  .p-button.p-button-icon-only {
    display: none;
  }
  .p-datepicker .p-timepicker {
    border-top: none;
  }
`;

export function ScheduleDateTimeDialog({
  onClose,
  visible,
  selectedDate,
  setSelectedDate,
}: {
  onClose: () => void;
  visible: boolean;
  selectedDate: CalendarValueType;
  setSelectedDate: (date: CalendarValueType) => void;
}) {
  const {
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();
  const scheduledFirstCommunicationDate = watch(
    "scheduledFirstCommunicationDate"
  );
  const { getFormErrorMessage } = useFormValidation();
  const dateOfService = watch("dateOfService");
  const scheduledFirstCommunicationSent = watch(
    "scheduledFirstCommunicationSent"
  );

  const onOk = () => {
    setValue("scheduledFirstCommunicationDate", selectedDate, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    onClose();
  };

  const footerContent = (
    <div className="flex justify-content-between w-full">
      <InputText
        value={selectedDate?.toString()}
        placeholder="Selected date"
        disabled
      />
      <div className="flex gap-2">
        <Button
          label="Cancel"
          icon="pi pi-times"
          className="p-button-outlined"
          onClick={() => {
            onClose();
            setSelectedDate(
              scheduledFirstCommunicationDate ??
                dayjs().add(2, "minute").toDate()
            );
          }}
        />
        <Button
          label="Save"
          icon="pi pi-check"
          onClick={() => onOk()}
          autoFocus
        />
      </div>
    </div>
  );
  return (
    <Dialog
      header="Select date and time"
      visible={visible}
      style={{ width: "50vw", maxWidth: "630px" }}
      onHide={() => {
        if (!visible) return;
        onClose();
      }}
      footer={footerContent}
    >
      <div className="flex w-full">
        <div className="flex flex-column align-self-start w-full">
          <StyledCalendar
            showIcon
            placeholder="Schedule first message"
            value={selectedDate}
            todayButtonClassName="hidden"
            disabled={!!scheduledFirstCommunicationSent}
            minDate={dayjs().add(2, "minute").toDate()}
            maxDate={dayjs(dateOfService, "MM/DD/YYYY").endOf("day").toDate()}
            onChange={(e) => {
              setSelectedDate(e.value);
            }}
            inline
            showTime
            hourFormat="24"
            panelStyle={{
              display: "flex",
              width: "100%",
              gap: "2rem",
            }}
          />
          {getFormErrorMessage("scheduledFirstCommunicationDate", errors)}
        </div>
      </div>
    </Dialog>
  );
}
